import { useRef, useLayoutEffect, useEffect } from 'react'
import { CollisionsManager } from '../systems/World/EventsManager'

function useCollision(callback: Function, uuid: string): null {
  const subscribe = CollisionsManager.onCollide.bind(CollisionsManager)
  // Update ref
  const ref = useRef(callback)
  useLayoutEffect(() => void (ref.current = callback), [callback])
  // Subscribe/unsub
  useEffect(() => {
    const unsubscribe = subscribe(callback, uuid)
    return () => unsubscribe()
  }, [uuid, subscribe])
  return null
}

export default useCollision